module.exports = __webpack_public_path__ + "static/media/icn_back_dark2.9fd44a6b.svg";